import { render, staticRenderFns } from "./SupportBanner.vue?vue&type=template&id=1422571b&scoped=true"
import script from "./SupportBanner.vue?vue&type=script&lang=js"
export * from "./SupportBanner.vue?vue&type=script&lang=js"
import style0 from "./SupportBanner.vue?vue&type=style&index=0&id=1422571b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1422571b",
  null
  
)

export default component.exports